// src/nova-eventing.interface.ts
var InputType = {
  /**
   * Fallback for events triggered by the user from an unknown input
   */
  unknown: "unknown",
  mouse: "mouse",
  keyboard: "keyboard",
  touch: "touch",
  pen: "pen",
  /**
   * Used for events triggered by code processes
   */
  programmatic: "programmatic"
};
export {
  InputType
};
